import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiTarget, FiTrendingUp, FiUsers, FiCheckSquare } from 'react-icons/fi';

const CoreValues = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  const values = [
    {
      icon: <FiTarget className="w-6 h-6 text-white" />,
      title: "Quality Focus",
      description: "Dedicated to ensuring software excellence through comprehensive testing methodologies"
    },
    {
      icon: <FiTrendingUp className="w-6 h-6 text-white" />,
      title: "Continuous Growth",
      description: "Always learning and adapting to new technologies and testing approaches"
    },
    {
      icon: <FiUsers className="w-6 h-6 text-white" />,
      title: "Team Collaboration",
      description: "Strong experience working with cross-functional teams and stakeholders"
    },
    {
      icon: <FiCheckSquare className="w-6 h-6 text-white" />,
      title: "Proven Results",
      description: "Track record of delivering high-quality software products on time"
    }
  ];

  return (
    <section id="core-values" className="section-padding bg-white dark:bg-dark-100 transition-colors duration-300">
      <div className="container-custom">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold text-secondary-800 dark:text-white mb-6">
            My <span className="gradient-text">Core Values</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-6">
          {values.map((value, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="bg-gradient-to-br from-primary-50 to-accent-50 dark:from-dark-200 dark:to-dark-300 p-6 rounded-xl shadow-md flex flex-col"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500 flex items-center justify-center mb-4">
                {value.icon}
              </div>
              <h3 className="text-lg font-bold text-secondary-800 dark:text-white mb-2">{value.title}</h3>
              <p className="text-secondary-600 dark:text-gray-100 text-sm leading-relaxed">
                {value.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreValues;
